import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import App from './App';

import { unregister } from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const sentryEnvironment = process.env.REACT_APP_SENTRY_ENV_NAME;
const sentryBuildNumber = process.env.REACT_APP_SENTRY_BUILD_NUMBER;

if (sentryEnvironment && sentryEnvironment.toLowerCase() !== 'dev') {
  Sentry.init({
    dsn: "https://ab10217062a3712956ef491d068cd894@o4504730772897792.ingest.us.sentry.io/4507788177506304",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: sentryEnvironment,
    release: process.env.REACT_APP_IS_DEV_ENVIRONMENT === 'true' ? undefined : `advisor-3-mt@${sentryBuildNumber}`
  });
}

const Root = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      const script = document.createElement('script');
      script.innerHTML = `
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:5140270,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `;
      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
      };
    }
  }, []);

  return (
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>
  );
};

ReactDOM.render(<Root />, rootElement);

unregister();
// registerServiceWorker(); //for some reason this blocked all server requests in a deployed environment



// WEBPACK FOOTER //
// ./src/index.js